<main class="admin-layout">
    <app-navbar></app-navbar>
  <router-outlet></router-outlet>
</main>
